import React from "react";
import { showToast } from "../../../../core/utils/alert";

interface ShareLinkModalProps {
  show: boolean;
  onClose: () => void;
  registrationLink: string | null;
  kitPending?: boolean;
}

const ShareLinkModal: React.FC<ShareLinkModalProps> = ({
  show,
  onClose,
  registrationLink,
  kitPending,
}) => {
  if (!show || !registrationLink) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(registrationLink);
    showToast({ text: "Link copied to clipboard!", icon: "success" });
  };

  const handleShare = () => {
    const text = encodeURIComponent(
      `Please click the link to complete your student registration:\n\n${registrationLink}`
    );
    window.open(`https://wa.me/?text=${text}`, "_blank");
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div
        className="modal fade show d-block"
        tabIndex={-1}
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Share Registration Link</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <p>
                Student registered successfully. Please share this link with the
                student or parents to complete their registration:
              </p>
              {kitPending && (
                <div className="alert alert-warning py-2 px-3 fs-13 mb-3 d-flex align-items-center">
                  <i className="ti ti-package-off text-warning fs-5 me-2"></i>
                  <span>
                    Starter kit pending (out of stock) — you can assign it from
                    the Student List anytime.
                  </span>
                </div>
              )}
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={registrationLink}
                  readOnly
                />
                <button
                  className="btn btn-outline-primary"
                  type="button"
                  onClick={handleCopy}
                >
                  <i className="ti ti-copy"></i> Copy
                </button>
                <button
                  className="btn btn-outline-success"
                  type="button"
                  onClick={handleShare}
                >
                  <i className="ti ti-brand-whatsapp"></i> Share
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={onClose}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareLinkModal;
